


























import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
  },
})
export default class ComponentFormButton extends Vue {
  @Prop({ default: false, type: Boolean }) readonly success!: boolean
  @Prop({ default: null, type: String }) readonly icon!: null
  @Prop({ default: false, type: Boolean }) readonly block!: boolean
  @Prop({ default: false, type: Boolean }) readonly primary!: boolean
  @Prop({ default: false, type: Boolean }) readonly loading!: boolean
  @Prop({ default: false, type: Boolean }) readonly outlinePrimary!: boolean
  @Prop({ default: false, type: Boolean }) readonly outlineSecondary!: boolean
  @Prop({ default: false, type: Boolean }) readonly gray!: boolean
  @Prop({ default: false, type: Boolean }) readonly grayLight!: boolean

  private $style!: IStyle

  private get classButton() {
    return {
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.button]: true,
      [this.$style.block]: this.block,
      [this.$style.success]: this.success,
      [this.$style.outlinePrimary]: this.outlinePrimary,
      [this.$style.outlineSecondary]: this.outlineSecondary,
      [this.$style.default]:
        !this.primary &&
        !this.outlinePrimary &&
        !this.gray &&
        !this.outlineSecondary,
      [this.$style.gray]: this.gray,
      [this.$style.grayLight]: this.grayLight,
    }
  }
}
